// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectFinishSchedulePdfMetadataQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  costCodeIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
  locationIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type ProjectFinishSchedulePdfMetadataQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
    | { __typename?: 'Region', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
    | { __typename?: 'Market', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
    | { __typename?: 'Community', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
    | { __typename?: 'Subdivision', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
    | { __typename?: 'Lot', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
    | { __typename?: 'Structure', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
    | { __typename?: 'Unit', id: string, name: string, readyPlanConfig?: { __typename?: 'ProjectReadyPlanConfig', id: string, readyPlan?:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
         | null | undefined, readyPlanOptions: Array<{ __typename?: 'ReadyPlanOption', id: string, order: number, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number } }> } | null | undefined }
  , costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, locations: Array<{ __typename?: 'Location', id: string, name: string }> };


export const ProjectFinishSchedulePdfMetadataDocument = gql`
    query ProjectFinishSchedulePdfMetadata($projectId: ID!, $costCodeIds: [ID!]!, $locationIds: [ID!]!) {
  project(id: $projectId) {
    id
    name
    readyPlanConfig {
      id
      readyPlan {
        id
        name
      }
      readyPlanOptions {
        id
        ...Named
        type {
          id
          name
          order
        }
        order
      }
    }
  }
  costCodes(filter: {id: $costCodeIds, version: [2]}) {
    ...Named
  }
  locations(filter: {id: $locationIds, version: [2]}) {
    ...Named
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useProjectFinishSchedulePdfMetadataQuery__
 *
 * To run a query within a React component, call `useProjectFinishSchedulePdfMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectFinishSchedulePdfMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectFinishSchedulePdfMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      costCodeIds: // value for 'costCodeIds'
 *      locationIds: // value for 'locationIds'
 *   },
 * });
 */
export function useProjectFinishSchedulePdfMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables> & ({ variables: ProjectFinishSchedulePdfMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>(ProjectFinishSchedulePdfMetadataDocument, options);
      }
export function useProjectFinishSchedulePdfMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>(ProjectFinishSchedulePdfMetadataDocument, options);
        }
// @ts-ignore
export function useProjectFinishSchedulePdfMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>;
export function useProjectFinishSchedulePdfMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectFinishSchedulePdfMetadataQuery | undefined, ProjectFinishSchedulePdfMetadataQueryVariables>;
export function useProjectFinishSchedulePdfMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>(ProjectFinishSchedulePdfMetadataDocument, options);
        }
export type ProjectFinishSchedulePdfMetadataQueryHookResult = ReturnType<typeof useProjectFinishSchedulePdfMetadataQuery>;
export type ProjectFinishSchedulePdfMetadataLazyQueryHookResult = ReturnType<typeof useProjectFinishSchedulePdfMetadataLazyQuery>;
export type ProjectFinishSchedulePdfMetadataSuspenseQueryHookResult = ReturnType<typeof useProjectFinishSchedulePdfMetadataSuspenseQuery>;
export type ProjectFinishSchedulePdfMetadataQueryResult = Apollo.QueryResult<ProjectFinishSchedulePdfMetadataQuery, ProjectFinishSchedulePdfMetadataQueryVariables>;